import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

export type FilePayload = {
  id: string
  name: string
  createdAt: string
  modifiedAt: string
  createdBy: string
  modifiedBy: string
  progress: number
}

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  public constructor(private readonly http: HttpClient) {}

  public uploadFile(
    presignedUrl: string,
    file: File
  ): Observable<HttpEvent<FilePayload>> {
    const headers = new HttpHeaders({
      'Content-Type': 'text/csv',
    })
    return this.http.put<FilePayload>(presignedUrl, file, {
      headers,
      reportProgress: true,
      observe: 'events',
    })
  }
}
